import { HtmlError } from '@InstanceFactory';

export class Errors {
    public static invalidOperation(operation: string, why?: string): never {
        throw new InsightError(`Invalid operation ${operation}: ${why}`);
    }

    public static notImplemented(): never {
        throw new InsightError('Not implemented');
    }

    public static unsupported(message: string): never {
        throw new InsightError(`unsupported: ${message}`);
    }

    public static keyNotFound(key: any, where: string = ''): never {
        throw new InsightError(`Key '${key}' not found` + where ? ` in ${where}` : '');
    }

    public static deprecatedMethod<T = any>(method: keyof T): never {
        throw new InsightError(`Method ${method} deprecated`);
    }
}

/**
 * Base class for Error
 * see https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
 */
export class InsightError extends Error {
    constructor(message?: string) {
        const trueProto = new.target.prototype;
        super(message);
        Object.setPrototypeOf(this, trueProto);
    }

    public static throwIfOccurred(e: unknown): never | void {
        if (e instanceof this) {
            throw e;
        }
    }
}

export class AbortSignalError extends InsightError {
    constructor(method: string, message?: string) {
        super(`${method}: ${message ?? 'aborted'}`);
    }
}

export class ServerError extends InsightError {
    constructor(message: string, public readonly error: HtmlError) {
        super(message);
    }
}
